export default function TrustBar() {
  const items = [
    { icon: "ri-building-4-fill", text: "500+ Roofs Repaired & Replaced", color: "text-[#10B981]" },
    { icon: "ri-star-fill", text: "5-Star Rated Local Company", color: "text-amber-400" },
    { icon: "ri-shield-check-fill", text: "Licensed & Fully Insured", color: "text-[#10B981]" },
    { icon: "ri-flashlight-fill", text: "Same-Day Response Available", color: "text-[#10B981]" },
    { icon: "ri-medal-2-fill", text: "Lifetime Workmanship Warranty", color: "text-amber-400" },
  ];

  return (
    <section className="bg-[#111111] border-b border-white/8 py-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-wrap items-stretch divide-x divide-white/8">
          {items.map((item, i) => (
            <div key={item.text} className={`flex items-center gap-2.5 py-4 px-6 flex-1 min-w-max justify-center ${i === 0 ? "" : ""}`}>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} ${item.color} text-base`}></i>
              </div>
              <span className="text-white/85 font-body font-600 text-sm whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
